// utils/contractUtils.js

// Contract priority order for navigation (matching actual database contract names)
export const CONTRACT_PRIORITY = [
  'project',          // Projects
  'valve-audit',      // Valve Audit
  'hvac-maintenance', // HVAC Maintenance
  'mechanical-room',  // Mechanical Room
  'dryer-vent',       // Dryer Vents
  'stack-cleaning',   // Stack Cleaning
  'water_savings'     // Water Savings
];

/**
 * Determines the first available contract based on priority order
 * @param {Array} contracts - Array of contract strings from the building data
 * @returns {string|null} - The first available contract key, or null if none found
 */
export function getFirstAvailableContract(contracts) {
  if (!contracts || !Array.isArray(contracts) || contracts.length === 0) {
    return null;
  }

  // Check contracts in priority order
  for (const contract of CONTRACT_PRIORITY) {
    if (contracts.includes(contract)) {
      return contract;
    }
  }

  return null;
}

/**
 * Maps contract keys to their corresponding routes
 * @param {string} contractKey - The contract key from the database
 * @returns {string} - The corresponding route path
 */
export function mapContractToRoute(contractKey) {
  const routeMap = {
    'hvac-maintenance': '/',
    'project': '/projects',
    'valve-audit': '/valve-audit',
    'mechanical-room': '/mechanical-room',
    'dryer-vent': '/dryer-vents',
    'stack-cleaning': '/stack-cleaning',
    'water_savings': '/water-savings'
  };

  return routeMap[contractKey] || '/';
} 